import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import GroupsListView from "./groups-list.html";
import GroupsEditView from "./groups-edit.html";
import PersonImportView from "./import/person-import.html";
import FullGroupImportView from "./import/fullGroup-import.html";


angular.module("groups", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('groups', {
                url: "/groups",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('groups.list', {
                url: "/list",
                controller: "GroupsListCtrl",
                template: GroupsListView,
                cache: false,
                requiredPermission: ["GROUPS_READ"] 
            })            
            .state('groups.edit', {
                url: "/edit/:id",
                controller: "GroupsEditCtrl",
                template: GroupsEditView,
                cache: false,
                params: {
                    descendsFrom: null,
                    group_type: null,
                },
                requiredPermission: ["GROUPS_READ"]
            })
            .state('groups.import_people', {
                url: "/import_people",
                controller: "GroupsImportPeopleCtrl",
                template: PersonImportView,
                cache: false,
                requiredPermission: ["GROUPS_READ"],
                params: {
                    people: null,
                    group_id: 0
                }
            })
            .state('groups.import_group', {
                url: "/import_group",
                controller: "GroupsImportGroupCtrl",
                template: FullGroupImportView,
                cache: false,
                requiredPermission: ["GROUPS_READ"],
                params: {
                    groupRows: null,
                }
            })
    }])
;